import { URL_API_AUTH } from 'src/config';
import baseActions from '../baseActions';
import httpService from 'src/helpers/httpService';

const path = 'admin/merchants';
export const actionType = (action) => {
  return {
    request: `${action}_${path}_request`.toUpperCase(),
    success: `${action}_${path}_success`.toUpperCase(),
    error: `${action}_${path}_error`.toUpperCase(),
  };
};

const http = httpService();
const merchant = {
  ...baseActions(URL_API_AUTH, path, actionType),
  fetchDetail: (id, params) => {
    return (dispatch) => {
      dispatch({ type: actionType('fetchDetail').request });
      return http.get(`${URL_API_AUTH}/admin/merchants/${id}`, { params }).then(
        (response) => {
          dispatch({ type: actionType('fetchDetail').success, response: response.data });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('fetchDetail').error });
          throw error.response;
        },
      );
    };
  },
  createMerchant: (data) => {
    let newPath = path;
    if (data?.partner_id && data?.is_convert) {
      newPath = 'admin/partner-merchants';
    }

    return (dispatch) => {
      dispatch({ type: actionType('create').request });
      return http.post(`${URL_API_AUTH}/${newPath}`, data).then(
        (response) => {
          dispatch({ type: actionType('create').success });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('create').error });
          throw error.response;
        },
      );
    };
  },
  updateData: (data) => {
    return (dispatch) => {
      dispatch({ type: actionType('update').request });
      return http.put(`${URL_API_AUTH}/${path}/${data?.id}`, data).then(
        (response) => {
          dispatch({ type: actionType('update').success });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('update').error });
          throw error.response;
        },
      );
    };
  },
  deleteData: (id) => {
    return (dispatch) => {
      dispatch({ type: actionType('delete').request });
      return http.delete(`${URL_API_AUTH}/merchants/${id}`).then(
        (response) => {
          dispatch({ type: actionType('delete').success });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('delete').error });
          throw error.response;
        },
      );
    };
  },
  deleteMerchantPartner: (id) => {
    return (dispatch) => {
      dispatch({ type: actionType('delete').request });
      return http.delete(`${URL_API_AUTH}/admin/partners/by-merchant/${id}`).then(
        (response) => {
          dispatch({ type: actionType('delete').success });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('delete').error });
          throw error.response;
        },
      );
    };
  },
};
export default merchant;
